import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private readonly counter = signal(0);
  public readonly isLoading = computed(() => this.counter() > 0);

  public show(): void {
    this.counter.update((count) => count + 1);
  }

  public hide(): void {
    this.counter.update((count) => Math.max(0, count - 1));
  }
}
